module.exports = __webpack_public_path__ + "img/time.1eff3fa4.jpg";